import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Button, Typography, Container } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')({
    maxWidth: 900,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 30,
    marginTop: 20,
});

// ----------------------------------------------------------------------

export default function Page404() {
    return (
        <>
            <Helmet>
                <title>AI Exchange .Live | Page Does Not Exist</title>
            </Helmet>

            <Container>
                <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
                    <Card sx={{ width: '100%', px: 6, py: 4, mt: 2, mb: 1 }}>
                        <h2>
                            Sorry, page not found!
                        </h2>

                        <Typography sx={{ color: 'text.secondary' }}>
                            Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
                            spelling.
                        </Typography>
                        <Button sx={{ margin: 2 }} to="/" size="large" variant="contained" component={RouterLink}>
                            Go to Home
                        </Button>
                        </Card>
                </StyledContent>
            </Container>
        </>
    );
}
